// =============================================================================
//  Copyright : 2020 semantics GmbH
//  Date      : $Date: 2020-03-27 21:33:23 +0100 (Fri, 27 Mar 2020) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 109077 $
//  Purpose   : help package
// =============================================================================

export const templates = true
export const parts = true

import * as reducers from './reducers'
export {reducers}

import * as actions from './actions'
export {actions}
